import * as MUTATION_TYPES from "./mutation-types";

export const uiState = {
  ui: {
    headerHidden: false,
    footerHidden: false
  }
};

export const uiMutations = {
  [MUTATION_TYPES.UI_SET_HEADER_HIDDEN](state, payload) {
    state.ui.headerHidden = payload;
  },
  [MUTATION_TYPES.UI_SET_FOOTER_HIDDEN](state, payload) {
    state.ui.footerHidden = payload;
  }
};
